// extracted by mini-css-extract-plugin
module.exports = {"pillGroup":"SlopeFilter_pillGroup__31agO"};